export enum SqlResultActionType {
  SetOffset = 'sqlResults.SetOffset',
  SetPageSize = 'sqlResults.SetPageSize',
}
